import React from "react";

import PropTypes from "prop-types";

const Danger = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.33333 11C8.33333 11.3682 8.63181 11.6667 9 11.6667C9.36819 11.6667 9.66667 11.3682 9.66667 11V7.66667C9.66667 7.29848 9.36819 7 9 7C8.63181 7 8.33333 7.29848 8.33333 7.66667V11Z"
      fill="#B82426"
    />
    <path
      d="M10 14C10 13.4477 9.55228 13 9 13C8.44772 13 8 13.4477 8 14C8 14.5523 8.44772 15 9 15C9.55228 15 10 14.5523 10 14Z"
      fill="#B82426"
    />
    <path
      d="M7.25848 4.41335C8.02407 3.05883 9.97514 3.05883 10.7407 4.41335L15.9796 13.6821C16.7332 15.0154 15.77 16.6662 14.2385 16.6662H3.76074C2.22926 16.6662 1.26604 15.0154 2.01961 13.6821L7.25848 4.41335Z"
      stroke="#B82426"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

Danger.propTypes = {
  color: PropTypes.string,
};

export default Danger;
